module.exports = __webpack_public_path__ + "static/logolaladynamics-c8bef45a93f200233b43c4140d8a438d.png";